import React from 'react';
import { Modal } from 'react-bootstrap';
import { TiWarning } from 'react-icons/ti';
import { FaCheckCircle } from 'react-icons/fa';
import { MdInfo, MdError } from 'react-icons/md';
import './CustomModal.css';

const CustomModal = ({
  show,
  onHide,
  title,
  message,
  type = 'warning', // 'warning', 'success', 'error', 'info'
  confirmText = 'Aceptar',
  cancelText = 'Cancelar',
  onConfirm,
  onCancel,
  showCancel = true,
  confirmVariant = 'danger' // 'danger', 'success', 'primary', etc.
}) => {
  
  const getIcon = () => {
    switch(type) {
      case 'warning':
        return <TiWarning className="modal-icon warning-icon" />;
      case 'success':
        return <FaCheckCircle className="modal-icon success-icon" />;
      case 'error':
        return <MdError className="modal-icon error-icon" />;
      case 'info':
        return <MdInfo className="modal-icon info-icon" />;
      default:
        return <TiWarning className="modal-icon warning-icon" />;
    }
  };

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    if (onHide) onHide();
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    if (onHide) onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      keyboard={false}
      centered
      className="custom-modal"
    >
      <Modal.Body className="custom-modal-body">
        <div className="modal-icon-container">
          {getIcon()}
        </div>
        
        <h3 className="modal-title-custom">{title}</h3>
        
        <p className="modal-message">{message}</p>
        
        <div className="modal-buttons">
          {showCancel && (
            <button 
              className="modal-btn modal-btn-cancel"
              onClick={handleCancel}
            >
              {cancelText}
            </button>
          )}
          <button 
            className={`modal-btn modal-btn-confirm ${confirmVariant}`}
            onClick={handleConfirm}
          >
            {confirmText}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CustomModal;



// WEBPACK FOOTER //
// ./src/components/subcomponent/CustomModal.jsx